import React, { useEffect, useState } from 'react';
import { useNexaStore } from './NexaStore';
import { PromptWrapper, DisclaimerFooter, MessageContainer, MessageText } from './styled';
import Header from './Header';
import useSetTitle from './hooks/useSetTitle';
import ChatBox from './ChatBox';
import useGetSession from './hooks/useGetSession';
import { useParams } from 'react-router-dom';
import { logger } from '@src/utils/misc/logger';
import EventList from './Events';
import { useNexaGateCheck, NexaGateState } from './utils/nexaGateCheck';
import AdminAcceptanceBanner from './elements/AdminAcceptanceBanner';
import NexaTitleBanner from './Templates/NexaTitleBanner';
import { checkCanUseNexa } from '@src/globalStore/profileStore';
import NoPermissionBanner from './elements/NoPermissionBanner';
import WhatsNew from './Header/WhatsNew';
import { useAskNexaInit } from './hooks/useAskNexaInit';

function Content() {
  const { id } = useParams();
  const { isFetching } = useGetSession({ id });
  const { state: gateState, canEnable } = useNexaGateCheck();
  const canUseNexa = checkCanUseNexa();

  // Handle "Ask Nexa" initialization from dashboard contexts
  const { initialQuery, sessionReady, askRequest } = useAskNexaInit(isFetching);

  logger.log('useNexaStore', useNexaStore.getState());
  useSetTitle();

  // Show normal Nexa functionality when allowed
  if (gateState === NexaGateState.ALLOWED) {
    if (!canUseNexa) {
      return (
        <PromptWrapper>
          <WhatsNew />
          <MessageContainer>
            <NexaTitleBanner />
            <NoPermissionBanner />
          </MessageContainer>
        </PromptWrapper>
      );
    }

    return (
      <PromptWrapper>
        <Header />
        <EventList isFetching={isFetching} />
        <ChatBox initialQuery={initialQuery} sessionReady={sessionReady} askRequest={askRequest} />
        <DisclaimerFooter>
          Conviva&apos;s Nexa is built on LLM technology. LLMs can generate inaccurate output.
        </DisclaimerFooter>
      </PromptWrapper>
    );
  }

  // Show blocked/disabled states with banner
  return (
    <PromptWrapper>
      <WhatsNew />
      <MessageContainer>
        <NexaTitleBanner />
        {gateState === NexaGateState.BLOCKED ? (
          <AdminAcceptanceBanner can_enable={canEnable} />
        ) : (
          <MessageText>
            Nexa is not currently available. Please check back later or contact support for more
            information.
          </MessageText>
        )}
      </MessageContainer>
      <DisclaimerFooter>
        Conviva&apos;s Nexa is built on LLM technology. LLMs can generate inaccurate output.
      </DisclaimerFooter>
    </PromptWrapper>
  );
}

export default Content;
